module.exports = __webpack_public_path__ + "static/media/c3payholder.be5897df.svg";